/* The Hambledon: small behaviour fixes on top of Broadcast (loaded deferred). One block per task. */

/* T-187 Show the tag/type being viewed under the collection title. Menu links like
   /collections/womenswear?pf_t_product_type=Skirts filter through Boost (query string), which Liquid can't
   read, so fill [data-current-filter] from the Boost type/tag filters and keep it in step as filters change. */
(() => {
  if (!/^\/collections\//.test(location.pathname)) return;
  let el = document.querySelector("[data-current-filter]");
  let fromLiquid = el ? el.textContent.trim() : ""; // tag URLs (/collections/x/tag), rendered server side
  let last = null;
  // Boost-rendered collection headers have no line yet: add one under the title once it appears
  const attach = () => {
    if (el && document.contains(el)) return true;
    const shown = (t) => (t.checkVisibility ? t.checkVisibility({ visibilityProperty: true }) : t.offsetHeight > 0);
    const title = [...document.querySelectorAll(".hero__title")].find(shown);
    if (!title) return false;
    el = document.createElement("p");
    el.className = "collection__current-filter";
    el.setAttribute("data-current-filter", "");
    el.hidden = true;
    title.after(el);
    last = null;
    return true;
  };
  const update = () => {
    if (!attach()) return;
    if (location.search === last) return;
    last = location.search;
    const params = new URLSearchParams(location.search);
    const values = [];
    for (const [key, value] of params) {
      if (/^pf_t_/.test(key) && value) values.push(...value.split(","));
    }
    const text = values.length ? [...new Set(values)].join(" / ") : fromLiquid;
    el.textContent = text;
    el.hidden = !text;
  };
  update();
  // Boost renders the header and updates the URL (history.pushState) as filters change
  setInterval(update, 500);
  window.addEventListener("popstate", update);
})();
